var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavSingleOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.095 8.566-6.179-5.744C30.571 1.571 27.912.548 26.01.548H5.251c-1.903 0-3.46 1.448-3.46 3.216v34.735c0 1.769 1.557 3.216 3.46 3.216h31.831c1.903 0 3.46-1.448 3.46-3.216V14.055c0-1.769-1.101-4.239-2.447-5.489m-1.957 1.819c.135.125.27.28.402.455h-7.069V4.268c.188.122.354.247.489.373l6.179 5.744zm1.636 28.114c0 .349-.317.643-.692.643H5.251c-.375 0-.692-.295-.692-.643V3.764c0-.349.317-.643.692-.643H26.01c.209 0 .444.025.692.069v10.223H37.7c.047.231.074.449.074.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.898 18.884-11.561-1.695-5.17-10.566-5.17 10.566-11.561 1.695 8.366 8.225-1.975 11.613 10.341-5.483 10.341 5.483-1.975-11.613zM21.167 30.632l-7.302 3.872 1.394-8.201-5.908-5.808 8.164-1.197 3.651-7.462 3.651 7.462 8.164 1.197-5.908 5.808 1.394 8.201z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavSingleOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fav-single-off.svg";